// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Yj4Im","controls":"styles_controls__4Zfxc","charLimit":"styles_charLimit__2-hI1","input":"styles_input__2-DNo","send":"styles_send__1BvZl"};